import React from 'react';
import EdsStepProgress from '@hedtech/react-design-system/core/es/StepProgress';
import StepConnector from '@material-ui/core/StepConnector';
const StepProgress = (props) => (React.createElement(EdsStepProgress, Object.assign({}, props)));
StepProgress.defaultProps = {
    activeStep: 0,
    alternativeLabel: false,
    connector: React.createElement(StepConnector, null),
    nonLinear: false,
    orientation: 'horizontal'
};
export default StepProgress;
